(function () {
    const $ = require('jquery');
    $('.jsToggleEnquireCard').on('click', function (e) {
        e.preventDefault();
        var $card = $(e.currentTarget).closest('.card');
        $card.find('.card__enquire').toggle();
        $card.find('.card__main').toggle();
    });
})();
